module.exports = __webpack_public_path__ + "static/contact-staticLR-82bb3401e73157bf326b4e2c0399044e.jpg";